import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  STANDBY_ENTRY_COMPLETION_RESULT_STORE_NAME,
  StandbyEntryCompletionResultState,
} from './standby-entry-completion-result.state';

/** Select StandbyEntryCompletionResult State */
export const selectStandbyEntryCompletionResultState = createFeatureSelector<StandbyEntryCompletionResultState>(
  STANDBY_ENTRY_COMPLETION_RESULT_STORE_NAME
);

/** Select StandbyEntryCompletionResult isPending status */
export const selectStandbyEntryCompletionResultIsPendingStatus = createSelector(
  selectStandbyEntryCompletionResultState,
  (state) => !!state.isPending
);

/** Select StandbyEntryCompletionResult isFailure status */
export const selectStandbyEntryCompletionResultIsFailureStatus = createSelector(
  selectStandbyEntryCompletionResultState,
  (state) => !!state.isFailure
);
